import { render, staticRenderFns } from "./case-base-info.vue?vue&type=template&id=5b0ee290&scoped=true"
import script from "./case-base-info.vue?vue&type=script&lang=ts"
export * from "./case-base-info.vue?vue&type=script&lang=ts"
import style0 from "./case-base-info.vue?vue&type=style&index=0&id=5b0ee290&prod&lang=less&scoped=true"
import style1 from "./case-base-info.vue?vue&type=style&index=1&id=5b0ee290&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0ee290",
  null
  
)

export default component.exports